import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/App";
import { CheckCircle2 } from "lucide-react";

export default function Success() {
  const loc = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth() || {};
  const [msg, setMsg] = useState("Confirming payment…");
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Lemon Squeezy grants credits/plan via webhook, so there is no session id to
    // check — instead we refresh the account a few times until the balance updates.
    let attempts = 0;
    let cancelled = false;
    const baseline = { credits: null };
    const poll = async () => {
      if (cancelled) return;
      attempts++;
      try {
        const r = await http.get(`/auth/me`);
        const u = r.data || {};
        if (baseline.credits === null) baseline.credits = (u.credits ?? 0) + (u.quota_left ?? 0);
        const now = (u.credits ?? 0) + (u.quota_left ?? 0);
        const upgraded = u.plan === "pro" || u.plan === "studio";
        if (now > baseline.credits || upgraded) {
          setMsg("Payment confirmed. Your account is updated.");
          setDone(true);
          refresh && (await refresh());
          setTimeout(() => nav("/dashboard", { replace: true }), 1600);
          return;
        }
      } catch {}
      if (attempts < 10) setTimeout(poll, 2000);
      else {
        // Webhook can lag a few seconds; send them to the dashboard where the live
        // balance shows regardless.
        setMsg("Payment received — updating your account…");
        refresh && (await refresh());
        setTimeout(() => nav("/dashboard", { replace: true }), 1800);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [loc.search, nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="tt-card p-10 text-center max-w-md">
        <CheckCircle2 size={48} className={done ? "text-[#10B981] mx-auto" : "text-zinc-400 mx-auto"} />
        <h1 className="mt-4 text-2xl font-extrabold h-tight" data-testid="success-msg">{msg}</h1>
      </div>
    </div>
  );
}
